import { useMemo } from 'react';

import { useGetStatisticsQuery } from '@/Module/DefaultLayout/Store/Query';

export const useStatistics = () => {
  const { data } = useGetStatisticsQuery();
  return useMemo(() => data, [data]);
};
